module.exports = __webpack_public_path__ + "static/media/lyssasky-IG.0511687e.PNG";